import instance from './instance';

// Service function to create a store file
export const createStoreFile = async (payload: any) => {return await instance.post('store-file', payload);};
